import React from 'react';
import { Link } from 'react-router-dom';

const AssessmentCard = ({ 
  assessmentCards, 
  outcomes, 
  handleStartClick,
  handleViewResponses,
  parentAssessmentName, 
  parentAssessmentDesc 
}) => {
  return (
    <>
      <h1 className="font-lg mb-4">{parentAssessmentName} </h1>
      <div className="dashboard-user-name">
        <p>
          {!parentAssessmentDesc || parentAssessmentDesc === "null" 
            ? "Description not available" 
            : parentAssessmentDesc}
        </p>
      </div>

      <div className="row mb-3">
        {assessmentCards && assessmentCards.length > 0 ? (
          assessmentCards.map((card) => (
            <div className="col-xl-6 mb-3" key={card.id}>
              <div className="assesment-cards">
                <div className="dashboard-title mb-3">
                  <div className="font-md fw-semibold">{card.title}</div>
                </div>
                {/* <p>{card.content || "Description Not Available"}</p> */}
                <div className="d-flex justify-content-end gap-2">
                  {outcomes[card.id] && (
                    <button
                      onClick={() => handleViewResponses(card.id, card.title)}
                      className="btn-assessment font-xss btns btn-animation-blue mt-xxl-4 mt-2 home-button"
                    >
                      View <i style={{marginLeft: '10px'}} className="fa-solid fa-eye"></i>
                    </button>
                  )}
                  <button
                    onClick={() => handleStartClick(card.id, card.title)}
                    className="btn-assessment font-xss btns btn-animation-blue mt-xxl-4 mt-2 home-button"
                  >
                    {outcomes[card.id] ? (
                      <>Edit <i className="fa-solid fa-edit icon"></i></>
                    ) : (   
                      <>Start Now <i className="fa-solid fa-right-long icon"></i></>
                    )}
                  </button>
                  
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12">
            <p>No assessments found</p>
          </div>
        )}
        <Link style={{ fontSize: "22px" }} to={"/user/assessments"}>
          <i className="fa-solid fa-left-long icon"></i> Back
        </Link>
      </div>
    </>
  );
};

export default AssessmentCard; 